import React, { useState, useMemo, useRef, useEffect } from "react";
import { CaretDown, MagnifyingGlass } from "@phosphor-icons/react";
import { COUNTRIES } from "@/lib/countries";

export default function PhoneInput({ code, number, onChange, inputClass = "" }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const selected = COUNTRIES.find((c) => c.dial === code) || COUNTRIES[0];
  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return COUNTRIES;
    return COUNTRIES.filter((c) => c.name.toLowerCase().includes(s) || c.dial.includes(s) || c.iso.toLowerCase().includes(s));
  }, [q]);

  return (
    <div className="flex gap-2 relative" ref={ref}>
      <div className="relative shrink-0">
        <button type="button" data-testid="phone-country" onClick={() => setOpen((v) => !v)}
          className={inputClass + " flex items-center gap-1.5 w-[96px] justify-center cursor-pointer"}>
          <span className="text-base leading-none">{selected.flag}</span>
          <span className="text-sm">{selected.dial}</span>
          <CaretDown size={12} className="text-[#9CA0B0]" />
        </button>
        {open && (
          <div className="absolute z-50 mt-2 w-72 rounded-2xl border border-zinc-200 bg-white shadow-xl overflow-hidden" data-testid="phone-country-dropdown">
            <div className="p-2 border-b border-zinc-100">
              <div className="relative">
                <MagnifyingGlass size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#9CA0B0]" />
                <input autoFocus data-testid="phone-country-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search country…"
                  className="w-full bg-[#F5F2ED] rounded-xl pl-9 pr-3 py-2 text-sm focus:outline-none" />
              </div>
            </div>
            <div className="max-h-56 overflow-y-auto">
              {filtered.map((c) => (
                <button key={c.iso + c.dial} type="button" data-testid={`phone-country-${c.iso}`}
                  onClick={() => { onChange(c.dial, number); setOpen(false); setQ(""); }}
                  className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-[#F5F2ED] text-sm">
                  <span className="text-base">{c.flag}</span>
                  <span className="flex-1 truncate text-[#0B1533]">{c.name}</span>
                  <span className="text-[#5A607A]">{c.dial}</span>
                </button>
              ))}
              {filtered.length === 0 && <p className="px-4 py-4 text-sm text-[#5A607A]">No results</p>}
            </div>
          </div>
        )}
      </div>
      <input type="tel" data-testid="phone-input" className={inputClass + " flex-1"} value={number}
        onChange={(e) => onChange(code, e.target.value)} placeholder="79 123 45 67" />
    </div>
  );
}
